<template>
	<div v-if="!loading">
		<div v-if="listOpen" class="z-backdrop fixed left-0 top-0 w-full h-full outline-none !bg-black/40"></div>
		<div class="bg-zt-light-full border-y border-zt-light rounded-t-zt font-semibold text-xs px-[11px] pt-3 pb-[11px] border-x">
			Zakłady długoterminowe
		</div>
		<div class="bg-zt-light/35 border-b border-zt-light px-2 py-2.5 border-x">
			<div>
				<div v-click-outside="clickOutside" class="relative w-full" ref="list" :class="[{ 'z-modal' : listOpen && window.size.desktop },
				 Object.keys(superbets).length <= 1 ? 'pointer-events-none opacity-50' : 'cursor-pointer']">
					<div @click="handleOpen"
					     class="w-full text-[13px] h-[38px] pl-[6px] pr-4 rounded-zt flex justify-between items-center border border-zt-light bg-zt-light/35">
						<Transition name="fade" mode="out-in">
							<div :key="selectedOption" class="flex items-center gap-x-[6px]">
								<span class="text-xs">{{ selectedOption }}</span>
							</div>
						</Transition>
						<svg :class="[{ 'rotate-180' : listOpen }, {'hidden' : Object.keys(superbets).length <= 1}]" class="transition" width="9" height="6" viewBox="0 0 9 6"
						     fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M0.99875 0.083984L4.25 3.32815L7.50125 0.0839843L8.5 1.08273L4.25 5.33273L1.94762e-07 1.08273L0.99875 0.083984Z"
								fill="white"/>
						</svg>
					</div>
					<template v-if="window.size.desktop">
						<Transition name="fade">
							<div v-if="listOpen"
							     class="bg-[#283344] w-full max-h-[316px] overflow-y-auto absolute z-10 top-[44px] rounded-zt border border-zt-light shadow-zt xl:max-h-[304px]">
								<div v-for="(option, index) in Object.keys(superbets)" :key="option"
								     @click="changeOption(option)"
								     :class="{ 'border-b-0' : index === Object.keys(superbets).length - 1,
								               '!bg-zt-light hover:!bg-zt-light' : option === selectedOption}"
								     class="hover:bg-zt-light/35 bg-[#283344] cursor-pointer pl-[6px] result no-default-style text-[13px] border-zt-light py-2 h-[38px] border-b-[1px] flex items-center gap-x-[6px]">
									<p class="name font-normal">{{ option }}</p>
								</div>
							</div>
						</Transition>
					</template>
					<template v-else-if="listOpen">
						<SuperbetsSelectMobile @changed-option="(option) => changeOption(option)" @close-modal="handleOpen()"
						                       :options="Object.keys(superbets)" :selected-option="selectedOption" />
					</template>
				</div>
			</div>
		</div>
		<div class="border-b border-zt-light bg-zt-light/35 border-x">
			<div v-for="(item, index) in oddsToShow"
			     :class="{ 'border-b-0' : oddsToShow.length - 1 === index && (showAll || superbets[selectedOption].length <= 5) }"
			     class="flex py-[9px] items-center justify-between text-[13px] font-medium border-b border-zt-light px-2.5">
				<div class="flex gap-x-[6px]">
					<img v-if="item?.query_name" :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${item.query_name}.png`"
					     :alt="item.team_name" class="aspect-square object-contain"
					     width="20" height="20" />
					<img :src="`/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg`" width="20" height="20"
					     v-else-if="!selectedOption.toLowerCase().includes('król') && !(item?.api_league_id === '4' || item?.api_league_id === '9')" />
					<a v-if="item?.query_name" :href="`/wyniki-pilka-nozna/druzyny/${item.query_name}/`"
             data-count-click="Wygra ligę 1" class="no-default-style zt-hover test-[#EEEEE] font-normal">
						{{ item.team_name }}
					</a>
					<span class="test-[#EEEEE] font-normal" v-else>{{ item.team_name }}</span>
				</div>
				<div class="flex items-center">
					<hr class="border-r border-zt-light h-[21px] mr-3" />
					<a href="/kod-promocyjny-superbet/"  data-count-click="Wygra ligę 2" class="no-default-style zt-hover mr-2.5">
						<img :src="`/wp-content/themes/zawodtyper/assets/images/bukmacherzy/superbet-78.webp`" width="20" height="20" />
					</a>
					<p class="w-9 text-xs font-semibold">{{ formatOddsValue(item.price) }}</p>
				</div>
			</div>
			<div v-if="superbets[selectedOption].length > 5 && !showAll" @click="showAll = true"
			   class="text-xs text-center text-zt-more underline py-4">
				<span class="cursor-pointer zt-hover uppercase">Rozwiń</span>
			</div>
			<div class="text-xs px-2 border-t border-zt-light text-zt-more py-4 flex items-center gap-x-2">
				<div>
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
						<path d="M9.70515 1.91016C9.39265 1.95703 8.96687 2.17188 8.7364 2.40234C8.50202 2.63281 8.91609 1.96094 4.15437 9.85547C1.23249 14.7031 0.150462 16.5312 0.084056 16.7305C0.00202476 16.9648 -0.00969399 17.0625 0.00593101 17.3984C0.0176498 17.7578 0.0332748 17.8164 0.162181 18.0859C0.435619 18.6328 0.951244 19.0078 1.54109 19.0938C1.91218 19.1445 18.0841 19.1445 18.4552 19.0938C19.045 19.0078 19.5606 18.6328 19.8341 18.0859C19.963 17.8164 19.9786 17.7578 19.9903 17.3984C20.0059 17.0625 19.9942 16.9648 19.9122 16.7305C19.8458 16.5312 18.7637 14.7031 15.8419 9.85547C11.0723 1.94922 11.4903 2.62891 11.2676 2.40625C10.8692 2.01172 10.2911 1.82812 9.70515 1.91016ZM10.2325 3.29688C10.3614 3.375 9.90827 2.64062 14.6856 10.5586C17.4512 15.1445 18.6466 17.1641 18.6583 17.2617C18.6817 17.4336 18.5919 17.6094 18.4356 17.7031C18.3341 17.7617 17.6387 17.7656 9.99812 17.7656C2.35749 17.7656 1.66218 17.7617 1.56062 17.7031C1.40437 17.6094 1.31452 17.4336 1.33796 17.2617C1.34968 17.1641 2.54499 15.1445 5.31062 10.5586C10.0723 2.66406 9.63484 3.37891 9.75984 3.30078C9.89265 3.21875 10.0958 3.21875 10.2325 3.29688Z" fill="#93A3BA"/>
						<path d="M9.56934 7.32038C9.37012 7.40632 9.18262 7.60554 9.13574 7.78523C9.08887 7.94538 9.10449 8.6446 9.18262 10.3048C9.20605 10.7657 9.2373 11.586 9.25293 12.129C9.28418 13.2305 9.29199 13.2579 9.57324 13.3985C9.76855 13.5001 10.1826 13.4923 10.4131 13.3868C10.6748 13.2618 10.7178 13.1524 10.7295 12.5704C10.7373 12.3009 10.7686 11.4766 10.7998 10.7344C10.9053 8.2032 10.9092 7.94538 10.8584 7.78132C10.7959 7.58601 10.6475 7.42585 10.4482 7.3321C10.2529 7.24226 9.76855 7.23445 9.56934 7.32038Z" fill="#93A3BA"/>
						<path d="M9.6233 14.3634C8.90455 14.6915 8.88112 15.7266 9.58424 16.0665C9.76784 16.1602 9.83424 16.172 10.0686 16.1563C10.3889 16.1407 10.596 16.0196 10.7952 15.7384C10.9046 15.5821 10.9124 15.547 10.9124 15.2345C10.9124 14.9337 10.9006 14.8751 10.8108 14.7384C10.678 14.5352 10.5999 14.4688 10.385 14.3712C10.1624 14.2696 9.83424 14.2657 9.6233 14.3634Z" fill="#93A3BA"/>
					</svg>
				</div>
				<div>
					<span class="leading-[184%] text-[10px]">
            Kursy mogą się różnić względem obecnej oferty bukmachera lub być chwilowo niedostępne, gdy rozgrywane są mecze
          </span>
				</div>
			</div>
		</div>
		<div class="bg-zt-light/35 border-b rounded-b-zt border-zt-light flex gap-y-[16px] flex-col px-4 items-center pt-[14px] border-x">
			<a href="/kod-promocyjny-superbet/" data-count-click="Wygra ligę 2" class="no-default-style zt-hover">
				<img :src="`/wp-content/themes/zawodtyper/assets/images/bukmacherzy/superbet-buk-miesiaca.png`" alt="Superbet" width="182" height="40" />
			</a>
			<div class="text-base text-center max-w-[315px]">
				<span v-html="text" />
			</div>
			<div @click="window.open(link, '_blank'); countClicks('Wygra ligę 2')" class="relative h-[58px] cursor-pointer">
				<div class="bg-white text-2xl text-black font-medium px-10 py-1 border border-dashed border-black absolute
							   -translate-x-2/3 left-1/2">
					<p class="my-auto font-bold">TYPERVIP</p>
				</div>
				<div class="shine-animation bg-zt-red rounded-zt py-[5px] px-4 !no-underline text-text zt-hover
							   font-semibold absolute left-1/2 translate-y-1 shadow-[0_2px_15px_0_rgba(196,12,12,.4)]
								 overflow-hidden active:text-text focus:text-text translate-x-[52px]">
					ODBIERZ
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import utils_mixin from "../../../mixins/utils_mixin";
import SuperbetsSelectMobile from "../blocks/SuperbetsSelectMobile.vue";

export default {
	name: 'SuperBets',
	components: {SuperbetsSelectMobile},
	inject: ['WP'],
	mixins: [utils_mixin],
	props: {
		leagueId: {
			type: String
		},
		leagueName: {
			type: String
		},
    type: {
      type: String,
      default: 'all'
    },
    defaultType: {
      type: String,
      default: 'Zwycięzca'
    }
	},
	data() {
		return {
			superbets: {},
			loading: true,
			clickOutside: {
				handler: () => { this.listOpen = false; this.unblockScrolling(); },
				events: ['touchend', 'mouseup']
			},
			listOpen: false,
			selectedOption: '',
			text: '',
			link: '',
			code: '',
			showAll: false
		}
	},
	methods: {
		handleOpen() {
			this.listOpen = !this.listOpen;
			if (this.listOpen) {
				if (window.size.desktop) {
					let extraOff = WP.user.adminBar ? -32 : 0;
					const y = this.$refs.list.getBoundingClientRect().top + window.pageYOffset + extraOff - 150;
					this.blockScrolling();
					window.scrollTo({top: y, behavior: 'smooth'});
				} else {
					this.blockScrolling();
				}
			} else {
				this.unblockScrolling();
			}
		},
		changeOption(option) {
			this.selectedOption = option;
			this.listOpen = false;
			this.unblockScrolling();
			// this.showAll = false;
		},
		formatOddsValue(value) {
			value = parseFloat(value);
			if (value >= 100) {
				return value;
			}
			if (value < 10) {
				return value.toFixed(2)
			}
			if (value >= 10) {
				return value.toFixed(1);
			}
		},
	},
	computed: {
		oddsToShow() {
			if (this.loading) {
				return [];
			}
			if (this.showAll) {
				return this.superbets[this.selectedOption];
			}
			if (!this.superbets[this.selectedOption]) {
				return [];
			}
			return this.superbets[this.selectedOption].slice(0, 5);
		}
	},
	async mounted() {
		const response = await axios.post(this.WP.ajaxUrl, {
			endpoint: 'api_get_league_superbets',
			league_id: this.leagueId
		})
		const responseText = await axios.post(this.WP.ajaxUrl, {
			endpoint: 'api_get_bookmaker_shirt',
			name: 'superbet'
		})

		this.text = responseText.data.data.text;
		this.link = responseText.data.data.link;
		this.code = responseText.data.data.code;
		this.text = this.text.replaceAll('<strong>', '');
		this.text = this.text.replaceAll('</strong>', '');
		this.text = this.text.replaceAll(/style="[^"]*"/g, 'class="font-semibold"');
    if (this.type !== 'all') {
      let round_pattern = new RegExp(this.type);
      this.superbets = Object.fromEntries(Object.entries(response.data.data).filter((el) => {
            return round_pattern.test(el[0]);
          }))
    } else {
      this.superbets = response.data.data;
    }
    let bets_names = Object.keys(this.superbets);
    if (this.defaultType !== '') {
      let index = bets_names.findIndex((el) => {
        return el === this.defaultType;
      })
      this.selectedOption = index !== -1 ? bets_names[index] : bets_names[0];
    } else {
      this.selectedOption = bets_names[0];
    }
		this.loading = false;
	}
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
	z-index: 10;
	transition: all 0.3s ease-out;
}

.fade-enter-from,
.fade-leave-to {
	z-index: 10;
	opacity: 0;
}
</style>